import { useEffect, useState } from "react";
import { adminEndpoints } from "@/lib/adminApi";
import { AdminPageHeader, AdminCard, EmptyState } from "@/components/admin/AdminUI";

export default function AdminCoursesPage() {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        adminEndpoints
            .courses()
            .then((d) => {
                if (!cancelled) setCourses(d);
            })
            .catch((err) => {
                if (!cancelled) setError(err?.response?.data?.detail || "Failed to load courses");
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div data-testid="admin-courses-page">
            <AdminPageHeader
                eyebrow="Training portal"
                title="Courses"
                description="Read-only view of the seeded course catalog. Editing lands in Phase 4."
                testId="admin-courses-header"
            />
            {error && (
                <p className="mb-6 border border-rose-400/40 bg-rose-500/10 px-4 py-3 font-mono text-xs text-rose-200">
                    {error}
                </p>
            )}
            {loading ? (
                <AdminCard>Loading…</AdminCard>
            ) : courses.length === 0 ? (
                <EmptyState title="No courses" testId="admin-courses-empty" />
            ) : (
                <div className="overflow-x-auto border border-white/10 bg-white/[0.02]">
                    <table className="min-w-full text-left text-sm" data-testid="admin-courses-table">
                        <thead className="border-b border-white/10 bg-white/[0.03] font-mono text-[10px] uppercase tracking-[0.2em] text-brand-offwhite/60">
                            <tr>
                                <th className="px-4 py-3">Title</th>
                                <th className="px-4 py-3">Category</th>
                                <th className="px-4 py-3">Level</th>
                                <th className="px-4 py-3 text-center">Lessons</th>
                                <th className="px-4 py-3 text-center">Enrolled</th>
                                <th className="px-4 py-3 text-center">Completed</th>
                            </tr>
                        </thead>
                        <tbody>
                            {courses.map((c) => (
                                <tr
                                    key={c.id}
                                    className="border-b border-white/5 last:border-0 hover:bg-white/[0.03]"
                                    data-testid={`admin-course-row-${c.id}`}
                                >
                                    <td className="px-4 py-3 font-body text-brand-offwhite">{c.title}</td>
                                    <td className="px-4 py-3 font-mono text-xs text-brand-gold">
                                        {c.category}
                                    </td>
                                    <td className="px-4 py-3 font-mono text-xs text-brand-offwhite/70">
                                        {c.level}
                                    </td>
                                    <td className="px-4 py-3 text-center font-display text-xl leading-none">
                                        {c.lesson_count}
                                    </td>
                                    <td className="px-4 py-3 text-center font-display text-xl leading-none">
                                        {c.enrolled_count}
                                    </td>
                                    <td className="px-4 py-3 text-center font-display text-xl leading-none text-brand-gold">
                                        {c.completed_count}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
